const types = {
  SCENE_ID: 'SCENE_ID',
  SCENE_NAME: 'SCENE_NAME',
  SCENE_LIST: 'SCENE_LIST',
  SCENE_INFO: 'SCENE_INFO',
  TRANSFOR: 'TRANSFOR',
}

const Scene = {
  state: {
    SCENE_LIST: [],
    SCENE_ID: 0,
    SCENE_NAME: '',
  },
  actions: {
    [types.SCENE_INFO]: async ({ commit }, sceneId) => {
      return commit(types.SCENE_INFO, sceneId)
    },
    [types.SCENE_LIST]: async ({ dispatch, commit }, list) => {
      return commit(types.SCENE_LIST, list)
    },
  },
  mutations: {
    [types.SCENE_INFO]: async (state, sceneId) => {
      const sceneList = state[types.SCENE_LIST]
      state[types.SCENE_ID] = sceneId
      sceneList.map(scene => {
        if (scene.scene_id === sceneId) {
          state[types.SCENE_NAME] = scene.scene_name
        }
      })
    },
    [types.SCENE_LIST]: async (state, list) => {
      state[types.SCENE_ID] = list[0].scene_id
      state[types.SCENE_NAME] = list[0].scene_name
      state[types.SCENE_LIST] = list
    },
  },
  getters: {
    getCurrentSceneId(state) {
      return state[types.SCENE_ID]
    },
    getCurrentSceneName(state) {
      return state[types.SCENE_NAME]
    },
    getVideoSceneList(state) {
      return state[types.SCENE_LIST]
    },
  },
}

export default Scene
